import FetchBase from '../Api/FetchBase'
import { observable, action } from 'mobx'
import { API_ENDPOINTS, DEFAULT_PAGE_START } from '../Utils/constants'
import { generateName } from '../Utils/rules'
import { generateFormData } from '../Utils/helpers'
import { ERROR_CODE } from '../Utils/constants'

export default class UsersStore extends FetchBase {
  @observable deleteUserByIdLoader = false

  @observable userByIdDetails = {}
  @observable customerOwners = []
  @observable allPosibileStatus = []

  @observable mediaCentricOwners = []

  @observable mediaCentricUsers = []
  @observable mediaCentricInactiveUsers = []
  @observable totalMediaCentricUsers = 0
  @observable totalMediaCentricInactiveUsers = 0

  @observable mediaCentricUsersPageNo = DEFAULT_PAGE_START
  @observable mediaCentricInActiveUsersPageNo = DEFAULT_PAGE_START

  @observable mediaCentricOwnersLoader = false
  @observable mediaCentricUsersLoader = true

  @observable selectedCustomerId = undefined

  @observable searchTextForUsersList = undefined
  @observable searchTextForInActiveUsersList = undefined

  @observable mediaCentricUsersRoles = []

  @observable usersFilters = {}
  @observable inactiveUsersFilters = {}

  @observable ordering = undefined
  @observable orderBy = undefined

  @observable inactiveordering = undefined
  @observable inactiveorderBy = undefined

  @observable asyncEmailCheckLoader = false

  @observable importUsers = []
  @observable importUsersFailures = []
  @observable importUserFromFileLoader = false

  @action.bound
  setAsyncEmailCheckLoder = (value = false) => {
    this.asyncEmailCheckLoader = value
  }

  @action.bound
  setOrdering = (value = undefined) => {
    this.ordering = value
  }

  @action.bound
  setOrderBy = (value = undefined) => {
    if (value === 'name') {
      value = 'fullName'
    } else if (value === 'createdAt') {
      value = 'createdOn'
    } else if (value === 'role') {
      value = 'roleName'
    }
    this.orderBy = value
  }

  @action.bound
  setOrderByInActive = (value = undefined) => {
    if (value === 'name') {
      value = 'fullName'
    } else if (value === 'createdAt') {
      value = 'createdOn'
    } else if (value === 'role') {
      value = 'roleName'
    }
    this.inactiveorderBy = value
  }

  @action.bound
  setOrderingInActive = (value = undefined) => {
    this.inactiveordering = value
  }

  @action.bound
  setUsersFilter = (filters) => {
    this.usersFilters = filters || {}
  }

  @action.bound
  setInActiveUsersFilter = (filters) => {
    this.inactiveUsersFilters = filters || {}
  }

  @action.bound
  getAllPosibleStatues = async () => {
    try {
      let response = await Promise.resolve({
        status: true,
        data: [
          {
            id: '1',
            name: 'Active',
            value: true,
          },
          {
            id: '2',
            name: 'Inactive',
            value: false,
          },
        ],
      })
      if (response.status) {
        this.allPosibileStatus = response.data
        return true
      } else {
        this.allPosibileStatus = []
        return false
      }
    } catch (err) {
      this.allPosibileStatus = []
      return false
    }
  }

  @action.bound
  setMediaCentricUsersPageNo = (value = DEFAULT_PAGE_START) => {
    this.mediaCentricUsersPageNo = value
  }

  @action.bound
  setMediaCentricInActiveUsersPageNo = (value = DEFAULT_PAGE_START) => {
    this.mediaCentricInActiveUsersPageNo = value
  }

  @action.bound
  setSearchTextForUsersList = (value = undefined) => {
    this.searchTextForUsersList = value
  }

  @action.bound
  setSearchTextForInActiveUsersList = (value = undefined) => {
    this.searchTextForInActiveUsersList = value
  }

  @action.bound
  setSelectedCustomerId = (id) => {
    this.selectedCustomerId = id
  }

  @action.bound
  sendUserPasswordById = async (id) => {
    try {
      let response = await this.post(API_ENDPOINTS.RESENT_PASSWORD_MAIL, {
        userId: id,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  deleteUserById = async (id) => {
    if (!id) return false
    try {
      this.deleteUserByIdLoader = true
      let response = await this.post(API_ENDPOINTS.DELETE_USER, {
        userId: id,
      })
      if (response.status) {
        return true
      } else {
        return false
      }
    } catch (err) {
      return false
    } finally {
      this.deleteUserByIdLoader = false
    }
  }

  @action.bound
  getUserById = async (id) => {
    if (!id) return false
    try {
      let response = await this.get(API_ENDPOINTS.USER_BY_ID, {
        userId: id,
      })
      if (response.status) {
        this.userByIdDetails = response.data
        return [true, this.userByIdDetails]
      } else {
        return [false, undefined]
      }
    } catch (err) {
      return [false, undefined]
    } finally {
    }
  }

  @action.bound
  updateUserById = async (id, details = {}) => {
    if (!id) return false
    const {
      firstName,
      lastName,
      email,
      avatar,
      role,
      title,
      customerId = undefined,
      city,
      state,
      country,
      contactNumber,
    } = details || {}
    try {
      let response = await this.postWithFormData(
        API_ENDPOINTS.UPDATE_USER,
        generateFormData({
          firstName,
          lastName,
          id,
          email: email ? email?.trim?.() : undefined,
          roleId: role,
          profileImage: avatar,
          title,
          customerId,
          state,
          country,
          contactNumber,
          city,
        })
      )
      if (response.status) {
        return [true, response.data]
      } else {
        return [false, undefined]
      }
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  getCustomerOwners = async (id) => {
    try {
      let response = await this.get(API_ENDPOINTS.CUSTOMER_USER_LIST, {
        customerId: id,
      })
      if (response.status) {
        this.customerOwners = response.data
        return true
      }
      this.customerOwners = []
      return false
    } catch (err) {
      console.log(err, 99)
      this.customerOwners = []
      return false
    }
  }

  @action.bound
  getCustomerOwnersReset = () => {
    this.customerOwners = []
    return
  }

  @action.bound
  getMediacentricOwners = async () => {
    try {
      this.mediaCentricOwnersLoader = true
      let response = await this.get(
        API_ENDPOINTS.DROP_DOWN_NEW_MEDIACENTRIC_USER_LIST
      )
      if (response.status) {
        this.mediaCentricOwners = response.data
        return true
      }
      this.mediaCentricOwners = []
      return false
    } catch (err) {
      this.mediaCentricOwners = []
      return false
    } finally {
      this.mediaCentricOwnersLoader = false
    }
  }

  @action.bound
  applyFilter() {
    let searchText = (this.searchTexForUsersList || '').toLowerCase()
    this.filteredUserList = (this.mediaCentricUsers || []).filter((user) => {
      const { firstName, lastName, email = '' } = user
      const name = generateName(firstName, lastName).toLowerCase()
      return name.includes(searchText)
    })
  }

  @action.bound
  getMediaCentricRoles = async (viaNetworkOnly = true) => {
    if (!viaNetworkOnly) {
      if (this.mediaCentricUsersRoles?.length) {
        return this.mediaCentricUsersRoles
      }
    }
    try {
      let response = await this.get(API_ENDPOINTS.MEDIACENTRIC_USERS_ROLES)
      if (response.status) {
        this.mediaCentricUsersRoles = response.data
        return [true, response.data]
      } else {
        return [false, undefined]
      }
    } catch (err) {
      return [true, undefined]
    }
  }

  @action.bound
  getFilters = () => {
    let options = {}
    const {
      status = undefined,
      role = undefined,
      inviteAccepted = undefined,
    } = this.usersFilters || {}
    options['isActive'] = status
    options['inviteAccepted'] = inviteAccepted
    role && (options['roleId'] = role)
    if (this.ordering) {
      options['ordering'] = this.ordering
      options['orderBy'] = this.orderBy
    }
    return options
  }

  @action.bound
  getFiltersInactive = () => {
    let options = {}
    const {
      status = undefined,
      role = undefined,
      inviteAccepted = undefined,
    } = this.inactiveUsersFilters || {}
    options['isActive'] = status
    options['inviteAccepted'] = inviteAccepted
    role && (options['roleId'] = role)
    if (this.inactiveordering) {
      options['ordering'] = this.inactiveordering
      options['orderBy'] = this.inactiveorderBy
    }
    return options
  }

  @action.bound
  getMediacentricUsersExportData = async ({ exportFileType = 'csv' } = {}) => {
    try {
      let options = {}
      let filters = this.getFilters()
      this.searchTextForUsersList &&
        (options['search'] = this.searchTextForUsersList)
      let response = await this.post(API_ENDPOINTS.EXPORT_MEDIACENTRIC_USERS, {
        ...options,
        ...filters,
        exportFileType,
        isActive: true,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  getMediacentricInactiveUsersExportData = async ({
    exportFileType = 'csv',
  } = {}) => {
    try {
      let options = {}
      let filters = this.getFiltersInactive()
      this.searchTextForInActiveUsersList &&
        (options['search'] = this.searchTextForInActiveUsersList)
      let response = await this.post(API_ENDPOINTS.EXPORT_MEDIACENTRIC_USERS, {
        ...options,
        ...filters,
        exportFileType,
        isActive: false,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }
  @action.bound
  getMediacentricUsers = async (signal) => {
    try {
      this.mediaCentricUsersLoader = true
      let options = {}
      let filters = this.getFilters()
      options['pageNo'] = Math.max(this.mediaCentricUsersPageNo - 1, 0)

      this.searchTextForUsersList &&
        (options['search'] = this.searchTextForUsersList)
      let response = await this.post(
        API_ENDPOINTS.MEDIACENTRIC_USERS,
        {
          ...options,
          ...filters,
          isActive: true,
        },
        signal
      )
      if (response.status) {
        this.mediaCentricUsers = response.data.rows
        this.totalMediaCentricUsers = response.data.count
        return true
      }
      this.mediaCentricUsers = []

      return false
    } catch (err) {
      this.mediaCentricUsers = []

      return false
    } finally {
      this.mediaCentricUsersLoader = false
    }
  }

  @action.bound
  getMediacentricInactiveUsers = async (signal) => {
    try {
      this.mediaCentricUsersLoader = true
      let options = {}
      let filters = this.getFiltersInactive()
      options['pageNo'] = Math.max(this.mediaCentricInActiveUsersPageNo - 1, 0)

      this.searchTextForInActiveUsersList &&
        (options['search'] = this.searchTextForInActiveUsersList)
      let response = await this.post(
        API_ENDPOINTS.MEDIACENTRIC_USERS,
        {
          ...options,
          ...filters,
          isActive: false,
        },
        signal
      )
      if (response.status) {
        this.mediaCentricInactiveUsers = response.data.rows
        this.totalMediaCentricInactiveUsers = response.data.count

        return true
      }
      this.mediaCentricInactiveUsers = []

      return false
    } catch (err) {
      this.mediaCentricInactiveUsers = []

      return false
    } finally {
      this.mediaCentricUsersLoader = false
    }
  }

  @action.bound
  addMediaCentricUsers = async (values = []) => {
    values = (values || []).map((user) => {
      const {
        email,
        firstName,
        lastName,
        title,
        role,
        avatar,
        city,
        country,
        state,
        contactNumber,
        phoneExtension,
      } = user
      return {
        email: email ? email?.trim?.() : undefined,
        firstName,
        lastName,
        title,
        roleId: role,
        profileImage: avatar,
        city,
        country,
        state,
        contactNumber,
        phoneExtension,
      }
    })

    try {
      let response = await this.post(
        API_ENDPOINTS.ADD_BULK_MEDIACENTRIC_USERS,
        { users: values } // do values when it's supported by multiple entries.
      )
      if (response.status) {
        return [response.status, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  updateUserLocally = async (id, responseData) => {
    this.mediaCentricUsers = (this.mediaCentricUsers || []).map((user) => {
      if (user.id === id) {
        return responseData
      } else {
        return user
      }
    })
  }

  @action.bound
  updateMediaCentricUsers = async (id, value) => {
    const {
      email,
      firstName,
      lastName,
      title,
      role,
      avatar,
      city,
      state,
      country,
      contactNumber,
      phoneExtension,
    } = value
    value = {
      id,
      email: email ? email?.trim?.() : undefined,
      firstName,
      lastName,
      title,
      roleId: role,
      profileImage: avatar,
      country,
      state,
      city,
      contactNumber,
      phoneExtension,
    }
    try {
      let response = await this.postWithFormData(
        API_ENDPOINTS.UPDATE_MEDIACENTRIC_USER,
        generateFormData(value)
      )
      if (response.status) {
        return [response.status, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  deleteMediaCentricUsers = async (id) => {
    try {
      let response = await this.post(API_ENDPOINTS.DELETE_MEDIACENTRIC_USER, {
        userId: id,
      })
      if (response.status) {
        return [response.status, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  resendInvitation = async (values) => {
    try {
      let response = await this.post(API_ENDPOINTS.RESEND_INVITATION, {
        ...values,
      })
      if (response.status) {
        return [response.status, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  addTeam = async (values = {}) => {
    const { customer = [], mediacentric = [], projectId } = values
    try {
      let response = await this.post(API_ENDPOINTS.ADD_TEAM, {
        projectId,
        userId: [...customer, ...mediacentric],
      })
      if (response.status) {
        return [true, response.data]
      }
      return false
    } catch (err) {
      return false
    }
  }

  @action.bound
  changeUserStatus = async (id, values = {}) => {
    try {
      let response = await this.post(API_ENDPOINTS.SET_USER_STATUS, {
        userId: id,
        ...values,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  importUsersFromFile = async (values) => {
    try {
      this.importUserFromFileLoader = true
      let formDataValues = generateFormData(values)
      let response = await this.postWithFormData(
        API_ENDPOINTS.IMPORT_USERS_FROM_FILE,
        formDataValues
      )
      if (response.status) {
        this.importUsers = response.data || []
        this.importUsersFailures =
          {
            headerMessage: response?.message || '',
            failedErrors: response.data?.failures || [],
            fileUpload: response.status,
            isError: true,
          } || []
        return [true, response.data]
      } else {
        return [false, undefined]
      }
    } catch (err) {
      if (err?.error?.statusCode === ERROR_CODE?.MENUAL_CODE) {
        this.importUsersFailures =
          {
            headerMessage: err?.message,
            failedErrors: null,
            fileUpload: false,
            isError: true,
          } || []
        return [false, undefined]
      } else {
        this.importUsersFailures =
          {
            headerMessage: err?.message,
            failedErrors: err?.error,
            fileUpload: false,
            isError: true,
          } || []
        return [false, undefined]
      }
    } finally {
      this.importUserFromFileLoader = false
    }
  }

  @action.bound
  importUsersFromFileReset = async () => {
    this.importUsers = []
    this.importUsersFailures = []
  }

  @action.bound
  resetUserFilters = () => {
    this.usersFilters = {}

    this.ordering = undefined
    this.orderBy = undefined
  }

  @action.bound
  resetInActiveUserFilters = () => {
    this.inactiveUsersFilters = {}

    this.inactiveordering = undefined
    this.inactiveorderBy = undefined
  }

  @action.bound
  resetStore = () => {
    this.deleteUserByIdLoader = false
    this.userByIdDetails = {}
    this.customerOwners = []
    this.mediaCentricOwners = []
    this.mediaCentricUsers = []
    this.mediaCentricInactiveUsers = []
    this.totalMediaCentricUsers = 0
    this.totalMediaCentricInactiveUsers = 0
    this.mediaCentricUsersPageNo = DEFAULT_PAGE_START
    this.mediaCentricInActiveUsersPageNo = DEFAULT_PAGE_START
    this.mediaCentricOwnersLoader = false
    this.mediaCentricUsersLoader = true
    this.selectedCustomerId = undefined
    this.searchTextForUsersList = undefined
    this.searchTextForInActiveUsersList = undefined
    this.mediaCentricUsersRoles = []
    this.usersFilters = {}
    this.inactiveUsersFilters = {}
    this.ordering = undefined
    this.inactiveordering = undefined
    this.orderBy = undefined
    this.inactiveorderBy = undefined

    this.allPosibileStatus = []

    this.importUsers = []
    this.importUsersFailures = []
    this.importUserFromFileLoader = false
  }
}
